import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { newbuildingChatOpenToggle } from '../../state/newbuildingConsultant';
import { NewbuildingConsultTopBanner } from './NewbuildingConsultTopBanner';
import { configSelector } from '../../../selectors/configSelector';

export function NewbuildingConsultTopBannerConatiner() {
  const dispatch = useDispatch();
  const open = React.useCallback(() => dispatch(newbuildingChatOpenToggle(true)), []);

  const config = useSelector(configSelector);
  const phone = config.get<string>('newbuildingConsultant.phone.moscowAndRegion');

  return <NewbuildingConsultTopBanner onChatClick={open} phone={phone} />;
}
